import { PENDING_USER_EMAIL_SET } from '../actions/SetPendingUserEmail';
import { USER_SIGNED_UP_EMAIL_RESENT } from '../actions/ResendSignUpEmail';

const initialState = {
  email: null,
};

const pendingUser = (state = initialState, action) => {
  switch (action.type) {
    case PENDING_USER_EMAIL_SET:
      return {
        ...state,
        email: action.email,
      };
    case USER_SIGNED_UP_EMAIL_RESENT:
      return {
        ...state,
        email: action.email,
      };
  }

  return state;
};

export default pendingUser;
